import React, { useCallback, useState } from "react";
import * as Scrivito from "scrivito";
import { getHomepage, getPageLink, getPageObj } from "utils";
import { useTranslate } from "hooks";
import { useAuthStore } from "stores/authStore";
import { Button } from "../Button";

export const LogoutButton = Scrivito.connect(({ isGray = false }) => {
  const translate = useTranslate();
  const [error, setError] = useState(null);

  const homepage = getHomepage();
  const homepageId = homepage.id();

  const { logout } = useAuthStore.use.actions();
  const isAuthenticated = useAuthStore.use.isAuthenticated();

  const handleLogOut = useCallback(async () => {
    try {
      homepageId && (await logout());
    } catch (err) {
      console.error(err);
      setError(err);
    }
  }, [homepageId, logout]);

  const parentObj = getPageObj("LoginPage");

  return (
    <>
      {error && <div className="text-danger">{translate("ERROR_LOGOUT")}</div>}
      {isAuthenticated ? (
        <Button
          data-testid="NavRightSidebar_logout-btn"
          color={isGray ? "secondary" : "primary"}
          size="lg"
          onClick={handleLogOut}
        >
          {translate("LEAVE_TROX_CONFIGURATOR")}
        </Button>
      ) : (
        <Scrivito.LinkTag
          data-testid="nav-right-sidebar_login-link"
          to={getPageLink(parentObj)}
          className="py-3 rounded-1 bg-blue-300 text-center text-uppercase text-decoration-none text-white"
        >
          {homepage.get("configuratorNavLogin")}
        </Scrivito.LinkTag>
      )}
    </>
  );
});
